import { useNavigate } from "react-router-dom";

import { useRecoilValue } from "recoil";
import { digitalLeadsSources, feedbackTypes } from "../constants/feedbackTypes";
import { useFileUploadService } from "../hooks/useFileUploadService";
import { userData } from "../recoil/atom/userData";
import { Loader } from "./Loader";

const FileUpload = () => {
  const user = useRecoilValue(userData);

  const {
    uploadFile,
    selectedFile,
    handleFileChange,
    isLoading,
    severity,
    alertOpen,
    alertMessage,
    feedbackType,
    setFeedbackType,
    fileInputRef,
    digitalLeadsSource,
    setDigitalLeadsSource,
  } = useFileUploadService();

  const navigate = useNavigate();

  const handleCancel = () => {
    navigate("/dashboard/sales");
  };
  const handleFileUpload = async () => {
    await uploadFile();
  };

  return (
    <div
      className="rounded-2xl p-8 w-full space-y-6"
      style={{ backgroundColor: "#1d2637" }}
    >
      <div>
        {user?.feedbackTypes?.length > 0 ? (
          <div>
            <h2 className="text-lg font-medium mb-3">Select Feedback Type</h2>
            <div className="flex gap-6">
              {user?.feedbackTypes?.map((type, index) => (
                <label
                  key={index}
                  className="flex items-center gap-2 cursor-pointer"
                >
                  <input
                    onChange={() => setFeedbackType(type)}
                    checked={type === feedbackType}
                    type="radio"
                    name="feedbackType"
                    className="accent-blue-500"
                  />
                  <span>{feedbackTypes[type]}</span>
                </label>
              ))}
            </div>
          </div>
        ) : null}
      </div>

      {feedbackType === "digital_lead" && (
        <div>
          <h2 className="text-lg font-medium mb-3">Select Source</h2>
          <div className="flex gap-6">
            {digitalLeadsSources?.map((type, index) => (
              <label
                key={index}
                className="flex items-center gap-2 cursor-pointer"
              >
                <input
                  onChange={() => setDigitalLeadsSource(type.value)}
                  checked={digitalLeadsSource === type.value}
                  type="radio"
                  name="source"
                  className="accent-blue-500"
                />
                <span>{type.label}</span>
              </label>
            ))}
          </div>
        </div>
      )}

      <div>
        <label className="block text-lg font-medium mb-3">
          Upload your file
        </label>
        <div className="flex items-center gap-4">
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
            accept=".xlsx,.csv,.xls"
            className="block w-full text-sm text-gray-300
                         file:mr-4 file:py-2 file:px-4
                         file:rounded-lg file:border-0
                         file:text-sm file:font-semibold
                         file:bg-blue-900 file:text-blue-200
                         hover:file:bg-blue-800"
          />
        </div>
      </div>

      {alertOpen && (
        <p
          style={{
            marginTop: 14,
            color: severity === "error" ? "red" : "green",
          }}
        >
          {alertMessage}
        </p>
      )}

      {isLoading ? (
        <div className="justify-center">
          <Loader />
        </div>
      ) : (
        <div className="flex !mt-10 gap-4">
          <button
            onClick={handleCancel}
            className="px-4 py-2 btn-danger text-gray-200 rounded-lg"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              handleFileUpload();
            }}
            disabled={!selectedFile}
            className="disabled:cursor-not-allowed disabled:bg-gray-400 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
          >
            Submit
          </button>
        </div>
      )}
    </div>
  );
};

export default FileUpload;
